<ng-template #timeline>
  <div class="timeline-container" [@inOut]="'in'">
    @if (history | annotateWithCompletedFlag; as historyList) {
      @if (historyList.length) {
        <ul class="timeline">
          @for (historyItem of historyList; track $index) {
            <li>
              @if (historyItem.type === 'ACTIVITY') {
                <crm-history-activity
                  [activity]="historyItem.activity"
                  (openActivityEvent)="onOpenActivity($event)"
                  (openTicketEvent)="onOpenTicket($event)"
                />
              } @else {
                <crm-history-ticket
                  [ticket]="historyItem.ticket"
                  [type]="historyItem.type"
                  (openTicketEvent)="onOpenTicket($event)"
                />
              }
            </li>
          }
        </ul>
      } @else {
        <p class="no-activities">
          {{ 'noActivities' | i18nextCap }}
        </p>
      }
    }
  </div>
</ng-template>

@if (bare) {
  <ng-container *ngTemplateOutlet="timeline" />
} @else {
  <crm-expansion-panel
    title="{{ 'history' | i18nextCap }}"
    [hideIfNotAllowed]="historyPermissions"
  >
    <ng-container *ngTemplateOutlet="timeline" />
  </crm-expansion-panel>
}
